export const formatNumber = (value) => {
  if (value === null || value === undefined) return "";
  const numericValue = typeof value === "number" ? value : parseFloat(value.toString().replace(/,/g, ''));
  if (isNaN(numericValue)) return "";
  return numericValue.toLocaleString("en-US");
};


// Convert number to words (basic implementation)
export const numberToWords = (num) => {
  const a = [
    '', 'one', 'two', 'three', 'four', 'five', 'six',
    'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve',
    'thirteen', 'fourteen', 'fifteen', 'sixteen',
    'seventeen', 'eighteen', 'nineteen'
  ];
  const b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

  const numberToWordsHelper = (n) => {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? '-' + a[n % 10] : '');
    if (n < 1000) return a[Math.floor(n / 100)] + ' hundred' + (n % 100 ? ' and ' + numberToWordsHelper(n % 100) : '');
    if (n < 1000000) return numberToWordsHelper(Math.floor(n / 1000)) + ' thousand' + (n % 1000 ? ' ' + numberToWordsHelper(n % 1000) : '');
    if (n < 1000000000) return numberToWordsHelper(Math.floor(n / 1000000)) + ' million' + (n % 1000000 ? ' ' + numberToWordsHelper(n % 1000000) : '');
    return 'number too large';
  };

  return numberToWordsHelper(Number(num)).replace(/\b\w/g, l => l.toUpperCase());
};
